import React from 'react';
import { Pencil, Trash2, Scissors, PauseCircle } from 'lucide-react';
import { tarihFarki } from './tarihHesaplamalari';

const accentMap = {
  emerald: { ring: 'border-emerald-200', icon: 'bg-emerald-50 text-emerald-600', Icon: Scissors },
  amber: { ring: 'border-amber-200', icon: 'bg-amber-50 text-amber-600', Icon: PauseCircle },
};

function sureMetni(s) {
  if (!s) return '';
  const p = [];
  if (s.yil) p.push(`${s.yil} yıl`);
  if (s.ay) p.push(`${s.ay} ay`);
  if (s.gun) p.push(`${s.gun} gün`);
  return `${p.join(' ') || '0 gün'} · ${s.gunSayisi} gün`;
}

function SebepKarti({ sebep, accent = 'emerald', onDuzenle, onSil }) {
  const a = accentMap[accent] || accentMap.emerald;
  const Icon = a.Icon;
  const isDurduran = Boolean(sebep.baslangic && sebep.bitis);
  const formatTarih = (t) =>
    new Date(t).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' });
  const sure = isDurduran ? tarihFarki(new Date(sebep.baslangic), new Date(sebep.bitis)) : null;

  return (
    <div className={`flex items-start gap-3 rounded-lg border bg-white p-3 shadow-sm ${a.ring}`}>
      <div className={`mt-0.5 shrink-0 rounded-md p-1.5 ${a.icon}`}>
        <Icon className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium leading-snug text-slate-800">{sebep.tip || 'Belirtilmedi'}</p>
        <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs tabular-nums text-slate-500">
          {isDurduran ? (
            <>
              <span>
                {formatTarih(sebep.baslangic)} → {formatTarih(sebep.bitis)}
              </span>
              <span className="text-slate-300">·</span>
              <span>{sureMetni(sure)}</span>
            </>
          ) : (
            <span>{formatTarih(sebep.tarih)}</span>
          )}
        </div>
        {sebep.aciklama ? (
          <p className="mt-1 line-clamp-2 text-xs text-slate-500">{sebep.aciklama}</p>
        ) : null}
      </div>
      <div className="flex shrink-0 items-center gap-0.5">
        <button
          type="button"
          onClick={onDuzenle}
          title="Düzenle"
          className="rounded-md p-1.5 text-slate-400 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
        >
          <Pencil className="h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={onSil}
          title="Sil"
          className="rounded-md p-1.5 text-slate-400 transition-colors hover:bg-rose-50 hover:text-rose-600"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}

export default SebepKarti;
